export const sxPointerEvents = { pointerEvents: "none" };
